import * as React from 'react';
import {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import folderIcon from "../../asset/icons/folder.png";
import folderSharedIcon from "../../asset/icons/folder-shared-2.png";
import homeIcon from "../../asset/icons/home_check.png";
import patientIcon from "../../asset/icons/patient.png";
import DriveService from "../../services/DriveService";
import StorageStatus from "../StorageStatus";
import useDrive from "../../hooks/useDrive";
import styled from "@emotion/styled";
import styles from "./fileTree.module.css";
import {Divider} from "@mui/material";
import {DRIVE_TYPES} from "../../config/appConst";
import {TreeItem, treeItemClasses, TreeView} from "@mui/x-tree-view";

const StyledTreeItemRoot = styled(TreeItem)(({theme}) => ({
    color: theme.palette.text.secondary,
    [`& .${treeItemClasses.content}`]: {
        color: theme.palette.text.secondary,
        borderTopRightRadius: theme.spacing(2),
        borderBottomRightRadius: theme.spacing(2),
        paddingRight: theme.spacing(1),
        fontWeight: theme.typography.fontWeightMedium,
        '&.Mui-expanded': {
            fontWeight: theme.typography.fontWeightRegular,
        },
        '&:hover': {
            backgroundColor: theme.palette.action.hover,
        },
        '&.Mui-focused, &.Mui-selected, &.Mui-selected.Mui-focused': {
            backgroundColor: `var(--tree-view-bg-color, ${theme.palette.action.selected})`,
            color: 'var(--tree-view-color)',
        },
        [`& .${treeItemClasses.label}`]: {
            fontWeight: 'inherit',
            color: 'inherit',
        },
    },
    [`& .${treeItemClasses.group}`]: {
        marginLeft: 0,
        [`& .${treeItemClasses.content}`]: {
            paddingLeft: theme.spacing(2),
        },
    },
}));

function StyledTreeItem(props) {
    const {
        iconColor,
        bgColor,
        color,
        labelIcon: LabelIcon,
        labelInfo,
        labelText,
        ...other
    } = props;

    return (
        <StyledTreeItemRoot
            label={
                <Box sx={{display: 'flex', alignItems: 'center', p: 0.5, pr: 0}}>
                    <img src={LabelIcon} className={styles.folderIcon} alt={"label icon"}/>
                    <Typography variant="body2" sx={{fontWeight: 800}}>
                        {labelText}
                    </Typography>
                    <Typography variant="caption" color="inherit">
                        {labelInfo}
                    </Typography>
                </Box>
            }
            style={{
                '--tree-view-color': color,
                '--tree-view-bg-color': bgColor,
            }}
            {...other}
        />
    );
}

StyledTreeItem.propTypes = {
    bgColor: PropTypes.string,
    color: PropTypes.string,
    labelIcon: PropTypes.elementType.isRequired,
    labelInfo: PropTypes.string,
    labelText: PropTypes.string.isRequired,
};

export default function FileTree() {
    const {CurrentDrive, changeCurrentDrive, deleteKey} = useDrive();
    const [tree, setTree] = useState([])
    const [sharedTree, setSharedTree] = useState([])
    // const [expandedNode, setExpandedNode] = useState('0');

    useEffect(() => {
        if (CurrentDrive) {
            loadSelected(CurrentDrive)
            // const {parent} = CurrentDrive;
            // setExpandedNode(parent? parent : "0");
        }
    }, [CurrentDrive])

    useEffect(() => {
        loadFolders()
    }, [])

    useEffect(() => {
        if(deleteKey) {
            let treeCp = [...tree];
            // console.log("treeCp", treeCp)
            tree.forEach((t, i) => {
                // console.log("last i", i)
                if (treeCp[i]) {
                    // console.log(treeCp[i].meAsParent)
                    // console.log(deleteKey)
                    if ( treeCp[i].meAsParent === deleteKey) {

                        treeCp.splice(i, 1);
                    }
                }

            });
            setTree(treeCp);
        }
    }, [deleteKey]);



    const loadFolders = async (parent = "", driveType = "") => {
        const res = await DriveService.getFileTree(parent, driveType);
        changeCurrentDrive({parent, drive: res, driveType});
    }
    const loadSelected = ({parent, drive, sharedDrive}) => {
        if (drive && drive.Folders) {
            setTree(loadATree(tree, drive, parent));
        }
        if (sharedDrive && sharedDrive.Folders) {
            setSharedTree(loadATree(sharedTree, sharedDrive, parent));

        }


    }
    const loadATree = (t, d, parent) => {
        const ft = [...t];
        d.Folders.map(folder => {
            const name = folder["Prefix"].replace('/', '');
            if (name) {
                const meAsParent = parent ? (parent + "/" + name) : name
                if (!ft.find(f => meAsParent === f.meAsParent)) {
                    ft.push({
                        name,
                        parent: parent,
                        meAsParent: meAsParent
                    })
                }
            }
        });

        return ft;
    }
    const loadFolder = (parentPath = "") => {
        const childrens = tree.filter(item => {
            return item.parent === parentPath;
        })

        return childrens.map(children => {
            const son = children.meAsParent
            // console.log(children.name)

            let newIcon = children.name === 'Patients' ? patientIcon : folderIcon;
            // return <TreeItem nodeId={son} label={children.name} labelIcon={Folder} onClick={() => {
            return <StyledTreeItem nodeId={son} labelText={children.name} labelIcon={newIcon} onClick={() => {
                loadFolders(son)
            }} style={{paddingLeft: "12px"}}>
                {loadFolder(son)}
            </StyledTreeItem>
        })
    }

    const loadSharedFolder = (parentPath = "") => {
        const children = sharedTree.filter(item => {
            return item.parent === parentPath;
        })
        // console.log(children);
        return children.map(children => {
            const son = children.meAsParent
            // console.log(children.name)

            return <StyledTreeItem nodeId={son} labelText={children.name} labelIcon={folderIcon} onClick={() => {
                loadFolders(son, DRIVE_TYPES.SHARED)
            }} style={{paddingLeft: "12px"}}>
                {loadSharedFolder(son, DRIVE_TYPES.SHARED)}
            </StyledTreeItem>
        })
    }
    const loadSharedDrive = async () => {
        // console.log("shared folders");
        const res = await DriveService.getFileTree("", "shared");
        // console.log(res);
        changeCurrentDrive({parent: "", sharedDrive: res, driveType: "shared"});
    }
    const HomeFolder = () => {
        return <StyledTreeItem nodeId={"home"} labelText="home" labelIcon={homeIcon} iconColor={"#e26784"} onClick={() => {
            loadFolders("")
        }}/>
    }
    const SharedFolder = () => {
        return <StyledTreeItem nodeId={"shared"} labelText="Shared (Beta)" labelIcon={folderSharedIcon} onClick={() => {
            loadSharedDrive()
        }} style={{paddingLeft: "0px", marginTop: "6px"}}>

        </StyledTreeItem>;
    }
    return (
        <div className={styles.root}>
            <div className="storageCmpContainer">
                <StorageStatus/>
            </div>
            <TreeView
                aria-label="gmail"
                // defaultExpanded={['0']}
                defaultCollapseIcon={<ArrowDropDownIcon/>}
                defaultExpandIcon={<ArrowRightIcon/>}
                defaultEndIcon={<div style={{width: 24}}/>}
                className={styles.folderTree}

            >
                <HomeFolder/>
                {
                    loadFolder("")
                }

            </TreeView>
            <TreeView
                aria-label="gmail"
                // defaultExpanded={['0']}
                defaultCollapseIcon={<ArrowDropDownIcon/>}
                defaultExpandIcon={<ArrowRightIcon/>}
                defaultEndIcon={<div style={{width: 24}}/>}
                className={styles.folderTree}

            >
                <Divider style={{padding: "2px", width: "90%", margin: "auto"}}/>
                <SharedFolder/>
                {
                    loadSharedFolder("")
                }
            </TreeView>
        </div>

    );
}
